var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 56,
    viewBox: "0 0 42 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0033 4.51951e-06C17.1513 -0.00256031 13.3729 1.08658 10.0818 3.14816C6.79081 5.20973 4.11411 8.16422 2.34489 11.6881C0.575677 15.2119 -0.217823 19.1692 0.0512957 23.1265C0.320415 27.0838 1.64177 30.8886 3.87066 34.124L4.01 34.3193L21.0029 56L37.9962 34.3222L38.1355 34.124C40.3619 30.888 41.6812 27.0837 41.9491 23.1273C42.217 19.171 41.4232 15.2149 39.6545 11.692C37.8858 8.16904 35.2103 5.21492 31.9208 3.15279C28.6312 1.09066 24.8544 -4.36902e-05 21.0033 4.51951e-06V4.51951e-06Z",
    fill: "url(#paint0_linear_534_685)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0062 34.7522C28.7416 34.7522 35.0124 28.4814 35.0124 20.746C35.0124 13.0105 28.7416 6.73975 21.0062 6.73975C13.2708 6.73975 7 13.0105 7 20.746C7 28.4814 13.2708 34.7522 21.0062 34.7522Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_534_685",
    x1: 21,
    y1: -28,
    x2: -32.76,
    y2: 12.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3176"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegSuccess);
export default __webpack_public_path__ + "static/media/regSuccess.96ba46929b1927d9d6e7ddc8f11bb74a.svg";
export { ForwardRef as ReactComponent };